import { render, staticRenderFns } from "./TempoSessao.vue?vue&type=template&id=0e0cdf98"
import script from "./TempoSessao.vue?vue&type=script&lang=js"
export * from "./TempoSessao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports